var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlackGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_737_53168",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_737_53168",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA7NJREFUWEe9l09um14Qx98Adpyde4P4BE1O8KsVJ0iwcFhn0XCCEsG+9jqQ0hNATuBUiUD5I+GeoL5B3V12ZREvUID5aZCpsH9gaKz8Zomf33zevJnvzAPWwCaTyV6n03EQ8QNjbM7zvCuK4rj416urq8+IqDHGuoyxKSKqqqrO67aHugXkfGdnJ2CM7RXXIuJYluURfXNd9wtjjJwXbY6IB6qqhpt81ALc3t5qHMeRg3ULoyjqhWHIAOB3mRNEPFdV1d4KwPM8lzH2sWwTAOg9PT3tAQBF6D9GUVJVNYtSlW0TATr52wMQued5Pxhj++un+N8AyLHv+2eIuHIVURQpYRjuv+kV1FWJ4zgftgaYTCbdVqt1JgjC+zqHLy8vv+I4dhVFyWq8KYDjOKQPZwDwHhG/k1aQTgDVebvd/gEAtKCphYjYl2V51gTAcZy8UopaQjrRB9/3g6XCNXWer5tJknTQEMAFgLJSdsHzPPxbz/n6ZRV0AYCqpFIHXNclnSAZX7c5AZCK/U34/2wSRdG7GiWkfuBuAJjBzc3NiOf5z6+IwldJkjL9r3CQ3TElWhUANaxMCV8B8XV3d3fU7/ezRrPMcLtwz9NWq3V+eno6qwCkJCaZtlek2Pf9lY5XFpVOpxPmjtd/X4J019tw/j1fX/z9D4CmaaQFe4iY5QMAhBcXF9kJctM0jQBD27ZLW2wQBPR7N47jjTn1/Pw8UxQl2yMDMAzjy3KYKPqbWpbVpw+6rlMJUVvNN3aTJDnPQShygiA4FZleml4cx40ODw/HYBgGTTJlLTMDoFPzPP+zZJdry7IU+v7w8DBhjJ28IpHPQdd12rzs7jMAwzBGiFhaJUmSvBsOhyyO49KBpA4IAOYEUKUDGYCu65UDSZIkPVEUmSAIZRGq8095lgGUqhTV6OXlpVsHYNv2/PHx8Sci1lbQOhHHcS4s73h96Cwm4MYIEEAQBPtxHNMejRWVTs/zfD+rAipBjuNOOI6jU0xN05zmtE0iQGuXlXCSpmktBDlfLBbXVIq1M2FTgNoLr1iwNcBwOCThWRnb0zT93m637SrFLLJsDSDLMl1b2Vg+Ozo6OqiLzFsCUJkpg8HgehPE1gCSJFUOJGmajkVR3O5hYhiGhohlT7O5ZVm9IAgoB6qeZurx8TGVcaXVRoBKlOd5GrlWhAYAxqZpZqe7u7sbcRy3ItdUaoPBoLd1Dix1ghoSOfuHnucA8M00zZVH5/39PY3cn2i6TtP022KxGOUtdxPEvwd0HWDqtT5rAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackGrey);
export default __webpack_public_path__ + "static/media/slack_grey.02c14cf8343910bbb08bba6a2ccf6875.svg";
export { ForwardRef as ReactComponent };